import { IsEnglish } from '@utils/language';

export function sortCcqJobTitle(data) {
    return data.sort(function (a, b) {
        const nameA = IsEnglish() ? a.descriptionE.toLowerCase() : a.descriptionF.toLowerCase()
        const nameB = IsEnglish() ? b.descriptionE.toLowerCase() : b.descriptionF.toLowerCase()
        if (nameA < nameB) //sort string ascending
            return -1
        if (nameA > nameB)
            return 1
        return 0 //default return value (no sorting)
    });
}

export function sortCcqJobTitleByCode(data) {
    return data.sort(function (a, b) {
        const nameA = a.ccqFunctionId
        const nameB = b.ccqFunctionId
        if (nameA < nameB) //sort string ascending
            return -1
        if (nameA > nameB)
            return 1
        return 0 //default return value (no sorting)
    });
}